/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetRiskBlockSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetRiskBlockRequest = {
  /**
   * The block ID (the underlying risk result ID).
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetRiskBlockSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetRiskBlockSecurity$outboundSchema: z.ZodMiniType<
  GetRiskBlockSecurity$Outbound,
  GetRiskBlockSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getRiskBlockSecurityToJSON(
  getRiskBlockSecurity: GetRiskBlockSecurity,
): string {
  return JSON.stringify(
    GetRiskBlockSecurity$outboundSchema.parse(getRiskBlockSecurity),
  );
}

/** @internal */
export type GetRiskBlockRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetRiskBlockRequest$outboundSchema: z.ZodMiniType<
  GetRiskBlockRequest$Outbound,
  GetRiskBlockRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getRiskBlockRequestToJSON(
  getRiskBlockRequest: GetRiskBlockRequest,
): string {
  return JSON.stringify(
    GetRiskBlockRequest$outboundSchema.parse(getRiskBlockRequest),
  );
}
